import React, { FC } from 'react';
import { Box } from '@mui/material';
import SofiForm from '../components/FormComponents/SofiForm';

const SofiScreen: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <SofiForm />
        </Box>
      </Box>
    </Box>
  );
};

export default SofiScreen;
